import { setupLayouts } from "virtual:meta-layouts"
import { createRouter, createWebHistory } from "vue-router/auto"
import { routesAdmin } from "./routers/admin"
import { routesAnket } from "./routers/anket"
import { routesAuth } from "./routers/auth"
import { routesEnvanter } from "./routers/envanter"
import { routesPlaka } from "./routers/plaka"
import { routesReceipt } from "./routers/receipt"
import { routesTanitim } from "./routers/tanitim"
import { routesUser } from "./routers/user"
import { routesOkulZiyaret } from "./routers/okulziyaret"
import { routesMenu } from "./routers/menu"
import { routesYapilacaklar } from "./routers/yapilacaklar"
import { routesMedia } from "./routers/media"

import { setupGuards } from "./guards"

function recursiveLayouts(route) {
  if (route.children) {
    for (let i = 0; i < route.children.length; i++)
      route.children[i] = recursiveLayouts(route.children[i])

    return route
  }

  return setupLayouts([route])[0]
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: "smooth", top: 60 }

    return { top: 0 }
  },
  extendRoutes: pages => [
    ...[
      ...pages,
      ...routesAuth,
      ...routesUser,
      ...routesTanitim,
      ...routesAdmin,
      ...routesAnket,
      ...routesEnvanter,
      ...routesReceipt,
      ...routesPlaka,
      ...routesOkulZiyaret,
      ...routesMenu,
      ...routesYapilacaklar,
      ...routesMedia,
    ].map(route => recursiveLayouts(route)),
  ],
})

setupGuards(router)
export { router }
export default function (app) {
  app.use(router)
}
